import type { SkyboxFeature } from "../features/SkyboxFeature";
// TODO: Remove in COTECH-2882
import { TopMarginApplier } from "../features/helpers/TopMarginApplier";
import type { TopStrategyParams } from "../TopStrategyTuner.types";
import type { TopStrategyTunerPlugin } from "../TopStrategyTunerPlugin";

export class SkyboxFeatureActivator {
  private activating: boolean = false;
  private feature?: SkyboxFeature;

  constructor(
    private readonly topStrategyTunerPlugin: TopStrategyTunerPlugin,
    // TODO: Remove in COTECH-2882
    private readonly marginApplier: TopMarginApplier = new TopMarginApplier(),
  ) {}

  activate(options: TopStrategyParams, callbackOnResolve: () => void) {
    if (this.activating || this.feature) {
      return;
    }

    this.activating = true;

    import("../features/SkyboxFeature")
      .then(({ SkyboxFeature }) => {
        // TODO: Remove `this.marginApplier` in COTECH-2882
        this.feature = new SkyboxFeature(this.marginApplier);
        this.feature.activate(
          this.topStrategyTunerPlugin,
          options,
          callbackOnResolve,
        );
        this.activating = false;
      })
      .catch(() => {
        this.activating = false;
        throw new Error("Failed to load SkyboxFeature");
      });
  }

  moveToResolvedState(options: TopStrategyParams) {
    if (!this.feature) return;
    if (this.feature.isStateResolved()) return;
    this.feature.makeStateResolved(options);
  }

  /**
   * Register a callback to be notified when the skybox state is resolved. If the skybox
   * feature is not active, then this function will do nothing.
   *
   * @param callback function to call when the skybox state is resolved.
   */
  onSkyboxStateResolved(callback: () => void) {
    if (!this.feature) return;
    this.feature.onSkyboxStateResolved(callback);
  }
}
